var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton-wrapper',{attrs:{"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('b-row',[_c('b-col',[_c('b-skeleton',{attrs:{"width":"50%"}}),_c('b-skeleton',{attrs:{"width":"25%"}})],1)],1)]},proxy:true}])},[_c('ReadOnly',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }